import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { LockKeyhole, ArrowLeft } from "lucide-react";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success(`Bem-vindo, ${res.user.name}`);
      const dest = location.state?.from || (res.user.role === "super_admin" ? "/super-admin" : "/admin");
      navigate(dest, { replace: true });
    } else {
      toast.error(res.error || "Falha no login");
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-10 border border-border/80 rounded-none shadow-none">
        <Link
          to="/"
          className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-foreground/60 hover:text-foreground mb-8"
          data-testid="login-back-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <LockKeyhole className="w-6 h-6" />
          <span className="text-xs uppercase tracking-[0.25em] text-foreground/60">Acesso da Plataforma</span>
        </div>
        <h1 className="font-heading text-5xl font-black tracking-tighter mb-10">Entrar</h1>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-[0.2em]">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seuemail@empresa.com"
              className="mt-2 h-12 text-base rounded-none"
              data-testid="login-email-input"
              autoFocus
              required
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em]">Senha</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-2 h-12 text-base rounded-none"
              data-testid="login-password-input"
              required
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full h-12 rounded-none text-base uppercase tracking-[0.2em] font-semibold"
            data-testid="login-submit-btn"
          >
            {submitting ? "Entrando…" : "Entrar"}
          </Button>
          <p className="text-xs text-foreground/50 leading-relaxed pt-2">
            Ainda não tem conta?{" "}
            <Link to="/signup" className="underline font-semibold hover:text-foreground" data-testid="login-goto-signup">
              Criar conta grátis
            </Link>
            {" "}· 14 dias sem cartão.
          </p>
        </form>
      </Card>
    </div>
  );
};

export default Login;
